module.exports = __webpack_public_path__ + "static/media/info.476f7c0c.svg";